import { useMutation, useQueryClient } from "@tanstack/react-query";
// API
import API from "./Api";

const useUpdateTaxiOrderApi = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, ...data }) => API.put(`api/taxi-orders/update-order/${id}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["AllTaxiOrders"] });
    },
  });
};

export default useUpdateTaxiOrderApi;
